var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 17H13.01V19H11V17Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15.001C11.2045 15.001 10.4416 15.3169 9.87903 15.8793L9.17181 16.5863L7.75781 15.1719L8.46503 14.4649C9.40266 13.5276 10.6742 13.001 12 13.001C13.3258 13.001 14.5974 13.5276 15.535 14.4649L16.2422 15.1719L14.8282 16.5863L14.121 15.8793C13.5584 15.3169 12.7955 15.001 12 15.001Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 11C11.0806 11 10.1704 11.1811 9.32106 11.5329C8.47176 11.8847 7.70006 12.4003 7.05005 13.0504L6.34296 13.7575L4.92871 12.3433L5.6358 11.6362C6.47153 10.8004 7.46371 10.1374 8.55567 9.68513C9.64763 9.23281 10.818 9 11.9999 9C13.1819 9 14.3522 9.23281 15.4442 9.68513C16.5361 10.1375 17.5283 10.8004 18.364 11.6362L19.0711 12.3433L17.6569 13.7575L16.9498 13.0504C16.2998 12.4003 15.5281 11.8847 14.6788 11.5329C13.8295 11.1811 12.9192 11 11.9999 11Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8099 10.2245C15.4826 5.92391 8.5162 5.92715 4.22198 10.2223L3.51495 10.9295L2.10059 9.5154L2.80762 8.80822C7.8854 3.72935 16.115 3.73259 21.2197 8.80597L21.929 9.51089L20.5192 10.9295L19.8099 10.2245Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.0dbd79a529f5f392dbc1c766db2359d2.svg";
export { ForwardRef as ReactComponent };